<!--
 * @Description: 财务小程序二维码
 * @Author: lijinpeng
 * @Date: 2024-04-25 11:30:09
 * @LastEditTime: 2024-04-25 13:53:13
 * @LastEditors: lijinpeng
-->
<template>
  <label>
    <el-popover
      v-if="show"
      placement="bottom"
      popper-class="shipment"
      trigger="hover"
      width="195"
      @hide="handleClick(false)"
      @show="handleClick(true)"
    >
      <div class="shipment_box_wrapper">
        <div class="textCenter font_16 _FFFFFF titles">小程序移动支付</div>
        <div class="shipment_box BG_FFFFFF">
          <img src="@/assets/images/home/qrCode_finance.jpg" />
        </div>
        <el-button class="downBtn" size="small" @click="handleClickShow">
          <a class="font_12 font_500">
            {{ downTitle }}
          </a>
        </el-button>
        <div class="footer textCenter _FFFFFF"></div>
      </div>
      <div
        slot="reference"
        :class="types ? 'qrcodeType' : 'qrcodeCom'"
        :style="{ right: right, top: top, width: width }"
        class="qrcodeBtn flexCon pointer"
      >
        <span class="iconfont icon-ma font_14" />
        <span class="font_12">{{ title }}</span>
      </div>
    </el-popover>
    <el-dialog :visible.sync="shows" append-to-body title="" width="527" @close="handleClose">
      <div class="wrap-aside">
        <div id="poster-aside" class="poster-aside">
          <div class="title _FFFFFF"></div>
          <div
            :style="{
              height: type === 'route' ? '536px' : '385px',
              'margin-bottom': type === 'route' ? '0px' : '22px',
            }"
            class="boxCenter BG_FFFFFF"
          >
            <div class="box_title ellipsis textCenter">
              <span> {{ groupName }}</span>
            </div>
            <div :style="{ 'margin-top': type === 'route' ? '15px' : '30px' }" class="box_img">
              <img src="@/assets/images/home/qrCode_finance.jpg" />
            </div>
            <div :style="{ 'margin-top': type === 'route' ? '27px' : '70px' }" class="box_logo">
              <img src="@/assets/images/svg/logo_black.svg" style="height: 21px; width: 155px" />
            </div>
          </div>
        </div>
      </div>
      <div class="flex boxFooter">
        <el-button @click="onExport">
          <div class="flex">
            <img src="@/assets/images/icons/down.png" />
            <span>下载</span>
          </div>
        </el-button>
      </div>
    </el-dialog>
  </label>
</template>

<script>
import html2canvas from 'html2canvas';

export default {
  name: 'ShipmentFinance',
  props: {
    // 是否展示 默认展示
    show: {
      type: Boolean,
      default: false,
    },
    // 信息
    info: {
      type: Object,
      default: () => {},
    },
    right: {
      type: String,
      default: '10px',
    },
    top: {
      type: String,
      default: '10px',
    },
    types: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '手机录单',
    },
    downTitle: {
      type: String,
      default: '发送给司机',
    },
    width: {
      type: String,
      default: '80px',
    },
  },
  data() {
    return {
      pureColor: false, // 二维码 触发前后的状态
      images: '',
      orderId: '',
      shows: false,
    };
  },
  computed: {
    groupName() {
      return this.$store.state.user.groupName;
    },
  },
  methods: {
    handleClick(val) {
      this.pureColor = val;
    },
    handleClickShow() {
      this.shows = true;
    },
    handleClose() {
      this.shows = false;
    },
    onExport() {
      this.logEvent('info', 'button', `下载`);
      var scale = 2; //放大倍数（增加导出海报的清晰度）
      html2canvas(document.querySelector('.poster-aside'), {
        dpi: window.devicePixelRatio * 1,
        scale: scale,
      }).then(canvas => {
        const dataURL = canvas.toDataURL('image/png');
        this.downloadIamge(dataURL, '牛运宝财务端');
      });
    },
    // 图片下载函数
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      const image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous');
      image.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        const url = canvas.toDataURL('image/png'); //得到图片的base64编码数据
        const a = document.createElement('a'); // 生成一个a元素
        const event = new MouseEvent('click'); // 创建一个单击事件
        a.download = name || 'photo'; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
  },
  watch: {
    info: {
      handler(val) {
        if (val) {
          this.orderId = this.info.orderId;
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.qrcodeBtn {
  position: absolute;
  min-width: 80px;
  height: 28px;
  border-radius: 4px;
  line-height: 28px;
  font-size: 13px;
  font-weight: 500;
  z-index: 2;

  .iconfont {
    margin: 0 5px 0 8px;
  }
}

.titles {
  height: 18px;
  max-width: 175px;
  margin: 15px 10px 0;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  line-height: 18px;
}

.diss {
  height: 9px;
  transform: scale(0.5);
  font-size: 20px;
  margin: 6px 0 17px 0;
  line-height: 9px;
  opacity: 0.7;
  font-family: PingFangSC-Regular, PingFang SC;
}

.footer {
  height: 9px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 9px;
  margin-top: 7px;
  opacity: 0.7;
  width: 220px;
  font-size: 20px;
  transform: scale(0.5, 0.5);
  margin: 7px auto 21px;
  margin-left: -10px;
}

.qrcodeType {
  background: #14183c;
  color: #fff;
}

.qrcodeCom {
  background: #f3f6fa;
  color: #666;
}

.qrcodeCom:hover {
  background: #dff8f1;
  color: #02bd8b;
}

.qrcodeCom:active,
.active {
  background: #dff8f1;
  color: #02bd8b;
}

.poster-aside {
  width: 422px;
  background: #00b182;
  padding-bottom: 26px;
  margin: 0 auto;
}
</style>
<style lang="scss">
.shipment {
  width: 195px;
  border-radius: 5px;
  background: #272847 !important;
  border: 1px solid #272847 !important;
  z-index: 40;
  margin-top: -3px;
  padding: 0 !important;

  .shipment_box {
    margin: 15px auto 7px !important;
    width: 130px;
    height: 130px;
    padding: 5px;
    background: #ffff;
    border-radius: 3px;

    img {
      width: 100%;
    }
    div > img {
      display: block;
      margin: 10px 11px 13px 12px;
      border-radius: 4px;
      width: 167px;
      height: 167px;
    }
  }

  .el-button {
    width: 130px;
    height: 28px;
    background: #02bd8b !important;
    border-radius: 4px;
    border: none;
    display: block;
    margin: 0 auto;

    span {
      a {
        color: #fff;
      }
    }
  }

  .el-button:hover {
    background: #64cdbf !important;
  }
}

.el-popover[x-placement^='bottom'] .popper__arrow {
  /*el-popover上边三角下层的颜色---也就是视觉上的边框*/
  border-bottom-color: #272847 !important;
}

.el-popover[x-placement^='bottom'] .popper__arrow::after {
  /*el-popover上边三角表层的颜色---也就是视觉上的角*/
  border-bottom-color: #272847 !important;
}

.el-popover {
  background: #272847 !important;
  border: 1px solid #272847 !important;
}
</style>
<style lang="scss" scoped>
.title {
  font-size: 32px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  font-family: PingFangSC-Semibold, PingFang SC;
  margin: 0 0 16px;
  padding-top: 30px;
}

.boxCenter {
  margin: 0 auto;
  width: 370px;
  border-radius: 8px;
  padding-bottom: 18px;
  box-shadow: 0px 2px 4px 0px rgba(0, 55, 41, 0.05);

  .box_title,
  .box_dis {
    width: 350px;
    margin-left: 10px;
  }

  .box_title {
    padding-top: 30px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
  }

  .box_dis {
    text-align: center;
    color: #02add5;
    margin: 8px 0 31px;
    height: 19px;
    font-size: 14px;
    color: #02add5;
    font-weight: 400;
  }

  .box_img {
    width: 177px;
    height: 177px;
    margin: 0 auto;

    img {
      width: 177px;
      height: 177px;
    }
  }

  .box_address {
    width: 343px;
    height: 136px;
    background: linear-gradient(180deg, #f3fffa 0%, #e6fff8 100%);
    border-radius: 8px;
    margin: 43px 14px 0;
    border-radius: 5px;
    padding-top: 6px;

    .send {
      height: 42px;
    }

    .box_item {
      display: inline-block;
      width: 21px;
      height: 21px;
      margin: 9px 11px 0 18px;
    }

    .ellipsis {
      width: 270px;
    }

    .add_city {
      height: 21px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
    }

    .add_addr {
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-top: 3px;
    }
  }

  .box-line {
    position: absolute;
    height: 30px;
    left: 120px;
    top: 480px;
    border-left: 0.5px dashed #e4e4e4;
  }

  .box_logo {
    margin-top: 15px;

    img {
      display: block;
      margin: 0 auto;
    }
  }
}

.boxFooter {
  margin-left: 78px;

  ::v-deep .el-button {
    padding: 0 !important;
    width: 370px;
    height: 49px;
    background: #009472;
    border-radius: 8px;
    border: none;
    line-height: 49px;

    img {
      display: inline-block;
      width: 16px;
      height: 15px;
      margin-top: 16px;
      margin-left: 155px;
      margin-right: 5px;
    }

    span {
      color: #ffffff;
      font-size: 18px;
    }
  }
}

::v-deep .el-scrollbar {
  z-index: 1 !important;
}

::v-deep .el-dialog {
  width: 527px;
  z-index: 3000;
  border: none;
}

::v-deep .el-dialog__header {
  padding: 0;
  margin: 0;
  height: 0;
}

::v-deep .el-dialog__body {
  padding: 0;
  margin: 0;
  background: #00b182;
  height: auto;
  width: 527px;
  padding-bottom: 37px;
}

::v-deep .el-dialog__close,
::v-deep .el-dialog__close:hover {
  color: #ffffff !important;
  font-size: 18px !important;
}

::v-deep .el-dialog__headerbtn {
  right: 12px;
  top: 12px;
  font-size: 9px;
}
</style>
